import React from "react";
import { Link } from "react-router-dom";
import "./Car.css";

import img6724 from "../images/Engine-car/synthetic/6724/pictures_FF6724_1_green_front_1200.jpg";
import img6726 from "../images/Engine-car/synthetic/6726/pictures_FF6726-1_green_front_1200.jpg";
import img6711 from "../images/Engine-car/synthetic/6711/pictures_FF6711-1_green_front_1200.jpg";
import img6702 from "../images/Engine-car/synthetic/6702/pictures_FF6702-1_green_front_1200.jpg";
import img6501 from "../images/Engine-car/synthetic/6501/pictures_FF6501-1_green_front_1200.jpg";
import img6707 from "../images/Engine-car/synthetic/6707/6707_1.png"

const carSections = [
  {
    id: "synthetic",
    title: "Synthetic Engine Oil",
    products: [
      { id: "6501", name: "FANFARO TSE 5W-30 6501", image: img6501 },
      { id: "6702", name: "FANFARO VSX 5W-40 6702", image: img6702 },
      { id: "6711", name: "FANFARO ESX 0W-40 6711", image: img6711 },
      { id: "6724", name: "FANFARO NSX 0W-20 6724", image: img6724 },
      { id: "6726", name: "FANFARO XTR 0W-30 6726", image: img6726 },
      { id: "6707", name: "FANFARO VDX 5W-30 6707", image: img6707 },
    ],
  },
];

const Car = () => {
  return (
    <>
      <div className="car-v4-page">
        <br />

        {/* Breadcrumb */}
        <nav className="app-breadcrumb">
          <Link to="/">Home</Link>
          <span className="separator">›</span>
          <Link to="/products">Products</Link>
          <span className="separator">›</span>
          <span className="current">
            Engine Oils for Cars & Transporters
          </span>
        </nav>

        {/* Sections */}
        {carSections.map((section) => (
          <section key={section.id} className="car-v4-section">
            <h2 className="car-v4-heading">{section.title}</h2>

            <div className="car-v4-grid">
              {section.products.map((product) => (
                <Link
                  key={product.id}
                  to={`/products/engine-oils-for-cars-and-transporters/engine-oil/${section.id}/${product.id}`}
                  className="car-v4-card"
                >
                  <div className="car-v4-img">
                    <img src={product.image} alt={product.name} />
                  </div>

                  <div className="car-v4-content">
                    <span className="car-v4-name">
                      {product.name}
                    </span>
                    <span className="car-v4-arrow-wrap">
                      <span className="car-v4-arrow">→</span>
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        ))}
      </div>

      {/* WhatsApp Button */}
      <a
        href="https://wa.me/7204731100?text=Hello%20I%20need%20details"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>
    </>
  );
};

export default Car;